// Unified API Base URL Configuration
// 1. If REACT_APP_API_URL is specified in .env, use that.
// 2. Otherwise in production, defaults to '' (relative path) so frontend & backend on the same domain work seamlessly.
// 3. In local development without REACT_APP_API_URL, defaults to '' so React proxy routes /api to http://localhost:5000.

const defaultBackendUrl = 'https://medical-backend-virid.vercel.app';
const envApiUrl = process.env.REACT_APP_API_URL;

const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE = envApiUrl 
  ? envApiUrl.replace(/\/+$/, '') 
  : (isLocalhost ? '' : defaultBackendUrl);

export const apiUrl = (endpoint) => {
  if (!endpoint) return API_BASE;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE}${cleanEndpoint}`;
};

export default apiUrl;
